import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2>About Us</h2>
          <div className="underline"></div>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            <h3>CloudShift Technologies Private Limited</h3>
            <p>
              We are a leading IT consultancy and software development company dedicated to 
              helping businesses transform their digital presence. With years of experience 
              in the industry, we have successfully delivered hundreds of projects across 
              various domains.
            </p>
            <p>
              Our team of skilled developers, designers, and consultants work collaboratively 
              to understand your unique business needs and deliver tailored solutions that 
              exceed expectations. We believe in building long-term partnerships with our 
              clients through trust, transparency, and exceptional service.
            </p>
            
            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-number">100+</span>
                <span className="stat-label">Projects Completed</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">Happy Clients</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">5+</span>
                <span className="stat-label">Years Experience</span>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <div className="image-placeholder">
              <div className="icon-grid">
                <span>💻</span>
                <span>📱</span>
                <span>☁️</span>
                <span>🚀</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
